export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    const el = document.createElement('span');
    el.textContent = text;
    el.style.all = 'unset';
    el.style.position = 'fixed';
    el.style.top = '0';
    el.style.clip = 'rect(0, 0, 0, 0)';
    el.style.whiteSpace = 'pre';
    el.style.webkitUserSelect = 'text';
    el.style.userSelect = 'text';

    document.body.appendChild(el);

    const range = document.createRange();
    range.selectNodeContents(el);

    const selection = window.getSelection();
    selection?.removeAllRanges();
    selection?.addRange(range);

    const success = document.execCommand('copy');

    selection?.removeAllRanges();
    document.body.removeChild(el);

    return success;
  } catch (err) {
    console.error('Copy failed', err);
    return false;
  }
};
